import React from 'react'
import { Chip, FormControlLabel, Grid, Switch, Typography } from '@mui/material'
import InputField from '../../../../../FormControl/input/InputField'
import { useParams } from 'react-router-dom'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import { toggleDialog } from '../../../../../../store/actions/periodical-report.actions'
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Skeleton from '@mui/material/Skeleton'
import SelectPeriodicalReport from '../../SelectCustom/SelectPeriodicalReport'
import SelectPeriod from '../../SelectCustom/SelectPeriod'

const FormBasicInformation = ({
  onChange,
  form = {},
  errors = {},
  isPreview,
  pathIsPreview,
  isLoading,
  type
}) => {
  const { periodicalReportId } = useParams()
  const dispatch = useDispatch()

  return (
    <Grid container spacing={1} alignItems='center' className={type === 'create' ? '' : 'h-72'}>
      {periodicalReportId && (
        <>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Status
            </Typography>
          </Grid>
          <Grid item sm={9} className='flex items-center gap-2'>
            {isLoading ? (
              <Skeleton variant='text' width={100} />
            ) : (
              <>
                <Chip
                  style={form.isCurrent ? { backgroundColor: 'var(--accent-foreground)' } : {}}
                  label={
                    <span className='flex items-center gap-1'>
                      {form.isCurrent && <FontAwesomeIcon icon='star' className='text-accent ml-1' />}
                      {form?.status?.replace(/-/g, ' ')}
                    </span>
                  }
                  className='uppercase'
                />
                {!pathIsPreview && form.isCurrent && (
                  <IconTooltipButton
                    id={`set-as-current-${periodicalReportId}`}
                    disabled={errors?.message}
                    title='Edit status'
                    icon='cog'
                    color='primary'
                    onClick={() => dispatch(toggleDialog('edit status', form))}
                  />
                )}
              </>
            )}
          </Grid>
        </>
      )}
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Code
        </Typography>
      </Grid>
      <Grid item sm={9}>
        {isLoading ? (
          <Skeleton variant='text' width={100} />
        ) : (
          <>
            {isPreview ? (
              <Typography variant='inherit' align='left' component='p'>
                {form.code}
              </Typography>
            ) : (
              <InputField
                id='code'
                name='code'
                error={errors.code}
                helperText={errors.code}
                value={form.code}
                onChange={(e) => onChange('code', e.target.value)}
              />
            )}
          </>
        )}
      </Grid>
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Name
        </Typography>
      </Grid>
      <Grid item sm={9}>
        {isLoading ? (
          <Skeleton variant='text' width={100} />
        ) : (
          <>
            {isPreview ? (
              <Typography variant='inherit' align='left' component='p'>
                {form.name}
              </Typography>
            ) : (
              <InputField
                id='name'
                name='name'
                error={errors.name}
                helperText={errors.name}
                value={form.name}
                onChange={(e) => onChange('name', e.target.value)}
              />
            )}
          </>
        )}
      </Grid>
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Year
        </Typography>
      </Grid>
      <Grid item sm={9}>
        {isLoading ? (
          <Skeleton variant='text' width={100} />
        ) : (
          <>
            {isPreview ? (
              <Typography variant='inherit' align='left' component='p'>
                {form.year}
              </Typography>
            ) : (
              <InputField
                id='year'
                name='year'
                error={errors.year}
                helperText={errors.year}
                value={form.year}
                onChange={(e) => onChange('year', e.target.value)}
              />
            )}
          </>
        )}
      </Grid>
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Period
        </Typography>
      </Grid>
      <Grid item sm={9}>
        <SelectPeriod
          id='period-select-form-basic-information'
          name='period'
          value={form.period}
          onChange={(e) => onChange('period', e.target.value)}
          loading={isLoading}
          error={errors.period}
          isPreview={isPreview}
        />
      </Grid>
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Previous Periodical Report
        </Typography>
      </Grid>
      <Grid item sm={9}>
        <SelectPeriodicalReport
          id='previousPeriodicalReportId'
          name='previousPeriodicalReportId'
          value={form.previousPeriodicalReportId}
          onChange={(e) => onChange('previousPeriodicalReportId', e.target.value)}
          loading={isLoading}
          isPreview={isPreview}
          error={errors.previousPeriodicalReportId}
        />
      </Grid>
      <Grid item sm={3}></Grid>
      <Grid item sm={type === 'create' ? 9 : 3}>
        <FormControlLabel
          control={
            <Switch
              color='primary'
              checked={form.enableRatings || false}
              readOnly={isPreview}
              onChange={isPreview ? undefined : (e) => onChange('enableRatings', e.target.checked)}
            />
          }
          label={
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Enable Ratings
            </Typography>
          }
          labelPlacement='end'
        />
      </Grid>
      {type === 'create' && (
        <>
          <Grid item sm={3}></Grid>
        </>
      )}
      <Grid item sm={type === 'create' ? 9 : 3}>
        <FormControlLabel
          control={
            <Switch
              color='primary'
              checked={form.enableEffortAndConduct || false}
              readOnly={isPreview}
              onChange={isPreview ? undefined : (e) => onChange('enableEffortAndConduct', e.target.checked)}
            />
          }
          label={
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Enable Effort And Conduct
            </Typography>
          }
          labelPlacement='end'
        />
      </Grid>
    </Grid>
  )
}

export default FormBasicInformation
